import React from 'react';
import {Atom, Plugins, withMeta, withSystem} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const Section = Atom.createRender(
  ({data, attributes, classes, generateAttributes, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
    const Tag = data.tag;
    return (
      <Tag {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

// Keep ElementSectionIcon even though other Layout icons render as Box.
const sectionIcon = qualify(Plugins.name('Layout'), iconName('Section'));

const config = createDevlinkAtom({
  displayName: 'Section',
  icon: {
    type: 'Derived',
    getFromElement: () => sectionIcon,
  },
  showEmpty: true,
  render: Section,
  fields: {
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'section',
          label: 'Tag',
          private: true,
          isLocalizable: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
    children: TListOfElement,
  },
});

export default config;
